import { render } from "./ChoiceQuestion.vue?vue&type=template&id=b1372c92&scoped=true&ts=true"
import script from "./ChoiceQuestion.vue?vue&type=script&lang=ts"
export * from "./ChoiceQuestion.vue?vue&type=script&lang=ts"

import "./style.scss?vue&type=style&index=0&id=b1372c92&lang=scss&scoped=true"
import "./ChoiceQuestion.vue?vue&type=style&index=1&id=b1372c92&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/deployJob/project/music-teach/h5-internal-examination/code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1372c92"]])

export default __exports__